import { render, staticRenderFns } from "./CommonMessageNotice.vue?vue&type=template&id=ed0dd31e&scoped=true"
import script from "./CommonMessageNotice.vue?vue&type=script&lang=js"
export * from "./CommonMessageNotice.vue?vue&type=script&lang=js"
import style0 from "./CommonMessageNotice.vue?vue&type=style&index=0&id=ed0dd31e&prod&lang=less"
import style1 from "./CommonMessageNotice.vue?vue&type=style&index=1&id=ed0dd31e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0dd31e",
  null
  
)

export default component.exports